import { createAsyncThunk } from '@reduxjs/toolkit';
import { isAxiosError } from 'axios';
import { discussionExportApi } from '~/apis/discussion-export';
import {
  DOWNLOAD_DISCUSSION_EXPORT_FILE,
  GET_CURRENT_DISCUSSION_EXPORT,
  START_DISCUSSION_EXPORT,
} from '~/utils/constants/actionType';
import { IBaseErrorData } from '~/utils/interface/base';
import { IBodyStartDiscussionExport, IPayloadDownloadDiscussionExportFile } from '~/utils/interface/discussionExport';

export const startDiscussionExport = createAsyncThunk(
  START_DISCUSSION_EXPORT,
  async (payload: IBodyStartDiscussionExport, { rejectWithValue }) => {
    try {
      const res = await discussionExportApi.startDiscussionExport(payload);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCurrentDiscussionExport = createAsyncThunk(
  GET_CURRENT_DISCUSSION_EXPORT,
  async (_payload: void, { rejectWithValue }) => {
    try {
      const res = await discussionExportApi.getCurrentDiscussionExport();
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/** Saves the file through a temporary link, so the Blob never goes into the store. */
export const downloadDiscussionExportFile = createAsyncThunk(
  DOWNLOAD_DISCUSSION_EXPORT_FILE,
  async (payload: IPayloadDownloadDiscussionExportFile, { rejectWithValue }) => {
    try {
      const res = await discussionExportApi.downloadDiscussionExportFile(payload.jobId);

      const url = URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = payload.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 1000);

      return payload.fileName;
    } catch (error) {
      // The error body of a blob request is a Blob too: read it to get the business code.
      if (isAxiosError(error) && error.response?.data instanceof Blob) {
        try {
          const data: IBaseErrorData = JSON.parse(await error.response.data.text());
          return rejectWithValue(data);
        } catch {
          // Not JSON (e.g. a proxy error page).
        }
      }
      return rejectWithValue(error);
    }
  }
);
